export default "__VITE_ASSET__Dms3cXsZ__"